<template>
  <div class="div-autocomplete" :style="{width: '100%'}">
    <ion-label position="floating">{{ label }}</ion-label>
    <ion-input 
      clear-input 
      type="text" 
      ref="input-algolia"
      :placeholder="placeholder || ''" 
      @ionInput="onInput" 
      @ionChange="onChange" 
      v-model="userInput" 
      @click="($event) => clickInput($event)"
      :disabled="computedDisabled" 
      />
    <ion-card class="suggestions-card " v-if="filteredSuggestions && filteredSuggestions.length">
      <ion-item v-for="(s, i) in filteredSuggestions" :key="i" @click="selected(s)" lines="none" :style="{fontSize: '.9em'}">
        <template v-if="attributesToHighlight && attributesToHighlight.length > 0">
          <span v-html="getHighlightResult(s)"></span>
        </template>
        <template v-else>
          <div>{{ typeof optionsKey == "function" ? optionsKey({element: s}) : s[optionsKey] }}</div>
        </template>
      </ion-item>
    </ion-card>
  </div>
</template>

<script>
import useAutoComplete from "../useAutoComplete";
import {IonCard, IonLabel, IonInput, IonItem, isPlatform} from "@ionic/vue";
export default {
  name: "AutoComplete",
  components: {
    IonCard,
    IonLabel,
    IonInput,
    IonItem,
  },
  emits:[
    'changed',
    'choiced'
  ],
  props: {
    attributesToHighlight: Array,
    label: String, 
    modelForm: null,
    msg: {
      type: String,
      required: false
    }, 
    options: Array, 
    optionsKey: null, 
    placeholder: String,
    disabled: Boolean,
    disabledObject: {
      type: Object
    },
    autofocus: {
      type: Boolean,
      default: false
    }
    // value: null
  },
  data() {
    return {
      disabledInput: false,
    };
  },
  computed: {
    computedDisabled() {
      return this.disabled || this.disabledInput
    }
  },
  watch: {
    options() {
      if (this.options && this.options.length > 0) {
        this.suggestions = this.options;
      } 
    },
    userInput(newValue) {
      if (!newValue || newValue.trim() === '') {
        this.isItemAvailable = false;
        this.$emit('changed', null)
      }
    },
    selectedItem(newValue) {
      this.$emit(`changed`, this.selectedItem.item)
      if (this.selectedItem.item && JSON.stringify(this.selectedItem.item) !== JSON.stringify(this.modelForm)) {
        this.$emit(`choiced`, this.selectedItem.item)
      }
    },
    modelForm(){
      // this.selected(this.modelForm)
    }
  },
  methods: {
    onInput(event) {
      // this.onChange(event)
    },
    onChange($event) {
      if(!$event.target.value) {//in case of cleared input
        this.filteredSuggestions = []
      }
    },
    clickInput($event) {
      if ($event && $event.target) {
        // if (isPlatform('ios')) {
          if ($event.target.nodeName === 'INPUT') {
            $event.target.select()
          } else {
            const childInput = [...$event.target.children].find(c => c.nodeName === 'INPUT')
            if (childInput) {
              childInput.select()
            }
          }
        // } else {
        //   $event.target.select()
        // }
      }
    },
    getHighlightResult(item){
      return this.attributesToHighlight.map(field => 
        (item._highlightResult 
          && item._highlightResult[field] 
          && item._highlightResult[field].matchedWords
          && item._highlightResult[field].matchedWords.length > 0
        ) ? item._highlightResult[field].value : item[field]
      ).join(' - ')
    },
    doSave: function(_clear) {
      if (_clear) {
        this.$emit("save-option", {});
        this.userInput = "";
      } else {
        this.$emit("save-option", this.selectedItem);
      }
    },
  },
  mounted() {
    this.$refs["input-algolia"].$el.setFocus()
  },
  created(){
    const { params = null, execDisable = null } = this.disabledObject || { params : null, execDisable : null }
    this.disabledInput = execDisable ? execDisable(params) || false : false
    if (this.modelForm && Object.keys(this.modelForm).length > 0) this.selected(this.modelForm)
  },
  setup(props) {
    return {
      ...useAutoComplete({options: props.options, optionsKey: props.optionsKey}),
    };
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  body {
    font-family: sans-serif;
  }

  .suggestions-card {
    /* padding: 4px; */
    opacity: 0.5;
    margin: 0em 1.5em .5em 1em;
    /* width: calc(100% -8px); */
    box-shadow: .1em .1em 1em .1em rgba(0, 0, 0, 0.2) !important;
  }
  .suggestions-card ion-item:not(:first-child) {
    border-top: .05em solid rgba(0, 0, 0, 0.2);
  }

  .label-floating {
    color: grey!important;
  }
</style>
